var STATE_DEFAULT = {
  loading: false,
  metadata: null
};
export var AVAILABLE_COUNTRIES_METADATA_LOAD = 'AVAILABLE_COUNTRIES_METADATA_LOAD';
export var AVAILABLE_COUNTRIES_METADATA_UPDATE = 'AVAILABLE_COUNTRIES_METADATA_UPDATE';
export default function availableCountriesMetadata() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STATE_DEFAULT;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case AVAILABLE_COUNTRIES_METADATA_LOAD:
      return Object.assign({}, state, {
        loading: true
      });

    case AVAILABLE_COUNTRIES_METADATA_UPDATE:
      return {
        loading: false,
        metadata: action.metadata
      };

    default:
      return state;
  }
}